import BaseScene from '@Scenes/BaseScene';
import EventEmitter from '@Utils/Events/EventEmitter';
import LanguageManager from '@Languages/LanguageManager';

/*--------------- Config ------------------------*/
import { ITrick } from '@Config/tricks';
import * as Scenes from '@Config/scenes';

/*------------------ Game -----------------------*/
import Game from '@Game';
import EventChannels from '@Config/event_channels';

/**
 * Score Scene,
 * Displays score and tricks
 */
class ScoreScene extends BaseScene
{
    /*------------- Phaser Objects -----------------*/

    private scoreText: Phaser.GameObjects.Text;
    private trickText: Phaser.GameObjects.Text;
    private trickScoreText: Phaser.GameObjects.Text;
    private trickTween: Phaser.Tweens.Tween;
    private trickScoreTween: Phaser.Tweens.Tween;

    /*----------------- Score ----------------------*/

    /**
     * Contructor
     */
    constructor()
    {
        super(Scenes.SCORE)
    }

    /**
     * Create score scene
     */
    public create()
    {
        this.createScoreText();
        this.createTrickScoreText();
        this.createTrickText();
        this.bindEvents();
        this.enableShutdown();
    }

    /**
     * Create Score Text
     */
    private createScoreText()
    {
        const gameSize = this.getGameSize();
        const fontStyle = { fontFamily: 'Permanent Marker', color: '#000000', align: 'center' };
        const scoreText = this.add.text(gameSize.centerX, 50, '0m', fontStyle);
        scoreText.setOrigin(0.5);
        scoreText.setFontSize(40);
        scoreText.alpha = 0;

        this.add.tween({ targets: scoreText, alpha: 1, duration: 500 });

        this.scoreText = scoreText;
    }

    /**
    * Create Trick Score Text
    */
    private createTrickScoreText()
    {
        const gameSize = this.getGameSize();
        const fontStyle = { fontFamily: 'Permanent Marker', color: '#999999', align: 'center' };
        const trickScoreText = this.add.text(gameSize.centerX, 95, '0', fontStyle);
        trickScoreText.setOrigin(0.5);
        trickScoreText.setFontSize(30);
        trickScoreText.alpha = 0;

        this.add.tween({ targets: trickScoreText, alpha: 1, duration: 300 });

        this.trickScoreText = trickScoreText;

        this.trickScoreTween = this.add.tween({
            targets: trickScoreText,
            scaleX: 1.2,
            scaleY: 1.2,
            yoyo: true,
            duration: 500,
        });

        this.trickScoreTween.pause();
    }

    /**
     * Create Trick Text
     */
    private createTrickText()
    {
        const gameSize = this.getGameSize();
        const fontStyle = { fontFamily: 'Permanent Marker', color: '#000000', align: 'center' };
        const trickText = this.add.text(gameSize.centerX, 200, '', fontStyle);
        trickText.setOrigin(0.5);
        trickText.setFontSize(25);
        trickText.setColor('#2d2d2d');
        this.trickText = trickText;

        this.trickTween = this.add.tween({
            targets: this.trickText,
            alpha: 0,
            scaleX: 0,
            scaleY: 0,
            y: 130,
            ease: 'Back.easeIn',
            duration: 500,
            delay:400
        });

        this.trickTween.pause();
    }

    /**
     * Binds to events
     */
    private bindEvents()
    {
        EventEmitter.on(EventChannels.PLAYER, 'trick', this.onTrick);
    }

    /**
     * Unbinds from events
     */
    private unbindEvents()
    {
        EventEmitter.off(EventChannels.PLAYER, 'trick', this.onTrick);
    }

    /**
     * Updates the scene
     */
    public update()
    {
        const player = Game.freerider.getPlayer();

        const runScore = Game.runScore;

        if (player.isAlive)
        {
            const position = player.vehicle.getFocalPoint().position;
            runScore.setDistanceScore(Math.floor(position.x / 100));
        }

        const distance = runScore.getDistanceScore();
        const trickScore = runScore.getTrickScore();

        this.scoreText.setText((distance + 'm').toString());
        this.trickScoreText.setText((trickScore).toString());
    }

    /**
     * On trick handler
     */
    private onTrick = (tricks: ITrick[]) =>
    {
        let trickText = [];
        let score = 0;

        for (let trick of tricks)
        {
            score += trick.value;
            trickText.push(LanguageManager.getLanguage(trick.key));
        }

        trickText.push(score);
        this.trickText.setText(trickText);
        this.trickTween.restart();
        this.trickScoreTween.restart();

        Game.runScore.addTricksToScore(tricks) ;
    }

    /**
     * Shuts down the scene
     */
    public shutdown()
    {
        this.unbindEvents();
    }

}

export default ScoreScene;